// extracted by mini-css-extract-plugin
export default {"ModalContent":"ModalContent-styles__ModalContent__Rxk3J"};